__turbopack_context__.v({
  "injectedContainer": "iYyryW_injectedContainer",
  "pseudoSliderWrapper": "iYyryW_pseudoSliderWrapper",
  "slider": "iYyryW_slider",
  "wrapper": "iYyryW_wrapper",
});
